export default __webpack_public_path__ + "static/media/pedidoOnline.292b2c2e.svg";